import React from 'react';
import { useStore } from '../../stores';
import { useTranslateFunction } from '../../helpers/useTranslationHook';

export const ButtonNavigate = () => {

  const { poi } = useStore();
  const { t } = useTranslateFunction('infolayer');
    
  return (

    <button
      className="w-full mr-3 border border-neutral-200 py-2 px-3 relative overflow-hidden cursor-pointer text-center text-neutral-600 text-sm rounded-xl transition-all hover:bg-brand-1 hover:text-white"
      onClick={() =>
        window.open(
          `https://www.google.com/maps/dir/?api=1&origin=Current+Location&destination=${poi.active.location.coordinates[1]},${poi.active.location.coordinates[0]}`,
          '_blank',
        )
      }
    >
      <span className="block text-lg icon icon-navigation"></span>
      {t('start_navigation')}
    </button>

  );
  
};